(() => {
  if (window.__hotspotGroupSliderInit) return;
  window.__hotspotGroupSliderInit = true;

  const closestSectionWrapper = (el) => {
    // Shopify wraps each section in #shopify-section-XXXX (often also .shopify-section)
    return el.closest('.shopify-section') || el.closest('[id^="shopify-section-"]');
  };

  const isJoinEnabled = (root) => String(root.dataset.hotspotSlider) === 'true';

  const buildSlider = (wrappers) => {
    if (!wrappers || wrappers.length < 2) return;

    const slider = document.createElement('div');
    slider.className = 'hotspot-group-slider';
    slider.setAttribute('data-hotspot-group-slider', '');

    const prev = document.createElement('button');
    prev.className = 'hotspot-group-slider__arrow hotspot-group-slider__arrow--prev';
    prev.type = 'button';
    prev.setAttribute('aria-label', 'Previous slide');
   prev.innerHTML = `
  <svg class="hotspot-group-slider__chev" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
    <path d="M9.5 3.5L5.5 8L9.5 12.5"></path>
  </svg>
`;

    const next = document.createElement('button');
    next.className = 'hotspot-group-slider__arrow hotspot-group-slider__arrow--next';
    next.type = 'button';
    next.setAttribute('aria-label', 'Next slide');
    next.innerHTML = `
  <svg class="hotspot-group-slider__chev" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
    <path d="M6.5 3.5L10.5 8L6.5 12.5"></path>
  </svg>
`;

    const viewport = document.createElement('div');
    viewport.className = 'hotspot-group-slider__viewport';
    viewport.tabIndex = 0;

    // Insert the slider before the first wrapper in the group
    wrappers[0].parentNode.insertBefore(slider, wrappers[0]);
    slider.appendChild(prev);
    slider.appendChild(viewport);
    slider.appendChild(next);

    // Move each original section wrapper into a slide
    wrappers.forEach((wrap) => {
      const slide = document.createElement('div');
      slide.className = 'hotspot-group-slider__slide';
      wrap.classList.add('hotspot-in-slider');
      slide.appendChild(wrap);
      viewport.appendChild(slide);
    });

    const slides = () => Array.from(viewport.children);

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    const getIndex = () => {
      const w = viewport.clientWidth || 1;
      return clamp(Math.round(viewport.scrollLeft / w), 0, slides().length - 1);
    };

    const updateButtons = () => {
      const idx = getIndex();
      prev.disabled = idx === 0;
      next.disabled = idx === slides().length - 1;
    };

    // Center arrows vertically on the media area of the active slide
    const updateArrowPosition = () => {
      const sliderRect = slider.getBoundingClientRect();
      const idx = getIndex();
      const slideEl = slides()[idx] || slides()[0];
      if (!slideEl) return;

      // Target the media container inside your section
      const media = slideEl.querySelector('.image-hotspot--inner');
      if (!media) return;

      const mediaRect = media.getBoundingClientRect();
      const centerY = (mediaRect.top - sliderRect.top) + (mediaRect.height / 2);

      // CSS reads this: top: var(--hotspot-arrow-top, 50%)
      slider.style.setProperty('--hotspot-arrow-top', `${centerY}px`);
    };

    const goTo = (idx) => {
      const w = viewport.clientWidth || 1;
      const target = clamp(idx, 0, slides().length - 1);
      viewport.scrollTo({ left: target * w, behavior: 'smooth' });

      // Update arrow position after scroll starts (and again on scroll event)
      window.requestAnimationFrame(() => {
        updateButtons();
        updateArrowPosition();
      });
    };

    prev.addEventListener('click', () => goTo(getIndex() - 1));
    next.addEventListener('click', () => goTo(getIndex() + 1));

    // Keep buttons + arrow position synced while user swipes
    viewport.addEventListener('scroll', () => {
      window.requestAnimationFrame(() => {
        updateButtons();
        updateArrowPosition();
      });
    });

    // Keyboard navigation
    viewport.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') goTo(getIndex() - 1);
      if (e.key === 'ArrowRight') goTo(getIndex() + 1);
    });

    // Recompute on resize
    const ro = new ResizeObserver(() => {
      // snap to current index after resize
      const idx = getIndex();
      const w = viewport.clientWidth || 1;
      viewport.scrollTo({ left: idx * w, behavior: 'auto' });

      updateButtons();
      updateArrowPosition();
    });
    ro.observe(viewport);

    // Initial state
    updateButtons();
    updateArrowPosition();
  };

  const init = () => {
    // Find all hotspot section roots in DOM order
    const roots = Array.from(document.querySelectorAll('.image-hotspot[data-hotspot-slider]'));

    // Map roots to their Shopify section wrappers (so we move the whole section)
    const items = roots
      .map((root) => {
        const wrap = closestSectionWrapper(root);
        if (!wrap) return null;
        return { root, wrap, join: isJoinEnabled(root) };
      })
      .filter(Boolean);

    if (!items.length) return;

    let i = 0;
    while (i < items.length) {
      const current = items[i];

      if (!current.join) {
        i += 1;
        continue;
      }

      // Start group: include consecutive wrappers where join is enabled
      const group = [current.wrap];
      let j = i;

      while (j + 1 < items.length) {
        const next = items[j + 1];
        const lastWrap = group[group.length - 1];

        // Only group if the next section is directly after in DOM (no gaps)
        const isConsecutive = lastWrap.nextElementSibling === next.wrap;
        if (!next.join || !isConsecutive) break;

        group.push(next.wrap);
        j += 1;
      }

      if (group.length >= 2) buildSlider(group);

      i = j + 1;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
